import "../Menu.scss";
import { useState } from "react";
import { Link } from "react-router-dom";
import cakeFeature1 from "../../../assets/menu/cakes/cake-feature1.jpeg";
import cakeFeature2 from "../../../assets/menu/cakes/cake-feature2.jpeg";
import cakeFeature3 from "../../../assets/menu/cakes/cake-feature3.jpeg";
import cakeFeature4 from "../../../assets/menu/cakes/cake-feature4.jpeg";
import {
  GFIcon,
  EgglessIcon,
  DairyFreeIcon,
  VeganIcon,
} from "../../../assets/global/Icons";
import Tooltip from "../../../common/Tooltip";
import Accordion from "../../../common/Accordion";
import MenuNav from "../MenuNav";
import MenuGallery from "../MenuGallery";
import cakeFlavors from "./cakeFlavors.json";
import fillingOptions from "./fillingOptions.json";
import frostingOptions from "./frostingOptions.json";
import sizingPricingOptions from "./sizingPricing.json";

function Cakes() {
  const [flavorsOpened, setFlavorsOpened] = useState(false);
  const [fillingsOpened, setFillingsOpened] = useState(false);
  const [frostingsOpened, setFrostingsOpened] = useState(false);
  const [sizesOpened, setSizesOpened] = useState(false);

  return (
    <div className="wrapper">
      <h1>
        <Link to="/menu" className="menu-title-link">
          Menu
        </Link>
      </h1>
      <MenuNav />

      <MenuGallery
        image1={{ src: cakeFeature1, alt: "Octonaut birthday cake" }}
        image2={{
          src: cakeFeature2,
          alt: "Elegant black white and gold birthday cake",
        }}
        image3={{
          src: cakeFeature3,
          alt: "Matcha cake with fresh strawberries and flowers",
        }}
        image4={{ src: cakeFeature4, alt: "Nutella chocolate drip cake" }}
      />

      <Accordion
        className="menu-accordion"
        title="Cake Flavors"
        isOpen={flavorsOpened}
        onToggle={() => setFlavorsOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Allergens: Contains milk, eggs, wheat. All cakes by default are{" "}
            <strong>free of tree nuts</strong>. While we are able to accommodate
            certain dietary restrictions, please note that this is not a
            dedicated gluten-free kitchen.
          </p>
        </div>
        {cakeFlavors.map((flavor) => (
          <div key={flavor.id}>
            <h3>{flavor.flavor}</h3>
            {flavor.specialty && <span className="specialty">*</span>}
            <p>{flavor.description}</p>
            <p>
              <em>{flavor.pairings}</em>
            </p>
            <p className="customizations-heading">
              <em>Optional Customizations:</em>
            </p>
            <div className="customizations-container">
              {flavor.allergens.map((allergen) => (
                <>
                  {allergen === "gf" && (
                    <Tooltip icon={<GFIcon />} text="Can be made gluten free" />
                  )}
                  {allergen === "eggless" && (
                    <Tooltip
                      icon={<EgglessIcon />}
                      text="Can be made eggless"
                    />
                  )}
                  {allergen === "dairy-free" && (
                    <Tooltip
                      icon={<DairyFreeIcon />}
                      text="Can be made dairy free"
                    />
                  )}
                  {allergen === "vegan" && (
                    <Tooltip icon={<VeganIcon />} text="Can be made vegan" />
                  )}
                </>
              ))}
            </div>
          </div>
        ))}
        <div className="full-width">
          <p>
            <em>
              <span className="specialty">*</span> = specialty flavors, extra
              fees apply
            </em>
          </p>
        </div>
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Frosting Options"
        isOpen={frostingsOpened}
        onToggle={() => setFrostingsOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            If you'd like to substitute the frosting on your cake, please select
            from the options below. Additional costs apply.
          </p>
        </div>
        {frostingOptions.map((option) => (
          <div key={option.id}>
            <h3>{option.option}</h3>
            <p>{option.description}</p>
            <p>
              <em>{option.pairings}</em>
            </p>
          </div>
        ))}
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Filling Options"
        isOpen={fillingsOpened}
        onToggle={() => setFillingsOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            If you'd like to add a filling between your cake layers, please
            select from the options below. Additional costs apply.
          </p>
        </div>
        {fillingOptions.map((option) => (
          <div key={option.id}>
            <h3>{option.option}</h3>
            <p>{option.description}</p>
            <p>
              <em>{option.pairings}</em>
            </p>
          </div>
        ))}
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Sizing & Pricing"
        isOpen={sizesOpened}
        onToggle={() => setSizesOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Standard cakes are 4 layers tall (~4 inches), with an option to
            upgrade to 6 layers for a taller look.{" "}
          </p>
          <p>
            Please note that starting prices reflect basic designs{" "}
            <em>without any customizations</em>. For custom or themed cakes that
            require additional artwork, please{" "}
            <Link to="/order">submit an order form</Link> to get a customized
            quote.
          </p>
        </div>
        {sizingPricingOptions.map((option) => (
          <div key={option.id}>
            <h3>{option.size}</h3>
            <p>
              {option.serves}
              <br />
              {option.pricing}
            </p>
          </div>
        ))}
      </Accordion>
    </div>
  );
}

export default Cakes;
